/* globals chrome */

import axios from "axios";
import { ActionType, BACKEND_URL, DataActionType } from "../constants";
import { IErrorAction, IPayloadAction, ICurrentTab, IDataActions } from "../types";

export async function getCurrentTabDetails(dispatch: Function): Promise<void> {
    try {
        let queryOptions = { active: true, lastFocusedWindow: true };
        let [tab] = await chrome.tabs.query(queryOptions);
        const actionPayload: IPayloadAction = {
            type: ActionType.ADD_URL,
            payload: {
                title: tab.title || "",
                url: tab.url || ""
            }
        }
        dispatch(actionPayload);
    } catch(err) {
        if (err instanceof TypeError) {
            const actionPayload: IPayloadAction = {
                type: ActionType.ADD_URL,
                payload: {
                    title: document.title,
                    url: document.URL
                }
            }
            dispatch(actionPayload);
        } else {
            const actionPayload: IErrorAction = {
                type: ActionType.ERROR,
                error: {
                    message: "Some error occurred",
                    status: true
                }
            }

            dispatch(actionPayload);
        }
    }
}

export async function addCurrentTabToList(userDataDispatch: Function, tabData: ICurrentTab, category: string | undefined): Promise<boolean> {
    try {

        const response = await axios.post(BACKEND_URL+"/data/addlink", {...tabData, category});
        if (!response.data.error) {
            const action: IDataActions = {
                type: DataActionType.UPDATE_DATA,
                payload: response.data.data
            }

            userDataDispatch(action);

            return true;
        }

        return false;

    } catch(err) {
        return false;
    }
}

export async function addNewCategory(userDataDispatch: Function, categoryName: string): Promise<boolean> {
    try {
        const response = await axios.post(BACKEND_URL+"/data/createcategory", {categoryName});
        if (!response.data.error) {
            const action: IDataActions = {
                type: DataActionType.UPDATE_DATA,
                payload: response.data.data
            }

            userDataDispatch(action);

            return true;
        }

        return false;
    } catch(err) {
        return false;
    }
}

export async function getDataOfSharedId(shareid: string | undefined) {
    try {
        const response = await axios.post(BACKEND_URL+"/data/getsharedlist", {shareid});

        if (!response.data.error) {
            return response.data.data;
        }

        return false;

    } catch(err) {

        return false;

    }
}